import React from 'react'
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom'
import { Button } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { Card } from "semantic-ui-react";
import { List, Segment } from 'semantic-ui-react'
import DestroyModal from "../generics/DestroyModal";

class InvoiceConfigurationsListItem extends React.Component {

  render () {
    const {invoiceConfiguration, view } = this.props
    return (
      <Card key={invoiceConfiguration.id}>
        <Card.Content as={NavLink} to={Routes.invoice_configuration_path({ id: invoiceConfiguration.id, _options: true})}>
          <Card.Header> {invoiceConfiguration.name} </Card.Header>
          <Card.Meta>{invoiceConfiguration.enterpriseNumber}</Card.Meta>

          {view === 'admin' &&
           <Card.Description>
             <Icon style={{color: invoiceConfiguration.scopeColor}} name="user"/> {invoiceConfiguration.scopeName}
           </Card.Description>
          }
        </Card.Content>
      </Card>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    view: state.view
  }
}

export default connect(mapStateToProps)(InvoiceConfigurationsListItem);


